import { FUNCTION_SPECS } from '../../shared/formula/functionRegistry';

export function validateAndStripCustomFunctions(formula) {
  let out = formula;

  try {
    for (const fn of FUNCTION_SPECS) {
      const regex = new RegExp(fn.pattern, fn.flags);
      
      
      out = out.replace(regex, (match, ...rest) => {
        const groups = rest.slice(0, -2);
      if (!fn.validate(groups)) {
        throw new Error(`Invalid ${fn.name}(...): ${fn.explain?.(groups) ?? 'check the arguments'}`);
      }
      return '1';
    });
    }
    
    // anything still bearing a known name never matched its pattern,
    // so validate() never ran on it
    const names = FUNCTION_SPECS.map((s) => s.name).join('|');
    const residual = out.match(new RegExp(`\\b(${names})\\s*\\(`, 'i'));
    if (residual) {
      throw new Error(`Malformed ${residual[1]}(...) — check the arguments`);
    }
  } catch (e) {
    return { ok: false, error: e?.message || 'Invalid function usage' };
  }

  return { ok: true, stripped: out };
}